import React from "react";
import { contact } from "../data";
import logo from "../logo-leasein.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <img src={logo} alt="LEASEIN" className="footer__logo" />
        <div className="footer__contact">
          <a href={`mailto:${contact.email}`}>{contact.email}</a>
          {contact.phones.map((p, i) => (
            <a key={i} href={`tel:${p.href}`}>{p.display}</a>
          ))}
        </div>
        <p className="footer__copy">
          © {new Date().getFullYear()} LEASEIN — Leasing Operațional. Toate
          drepturile rezervate.
        </p>
      </div>
    </footer>
  );
}
